<template>
  <div class="serviceStatistic-container">
    <a-row :gutter="12">
      <a-col :span="16" style="margin-bottom: 12px">
        <div
          class="statistic-module"
          @click="$router.push({
            name: 'ServiceDashboardList',
            params: { statusType: 'all' }
          })"
        >
          <a-statistic
            title="全部"
            :value="dataSource.all"
            :valueStyle="{
              fontSize: '38px',
              lineHeight: '44px',
              textAlign: 'center',
              color: 'rgba(0,0,0,.5)',
              cursor: 'pointer'
            }"
          ></a-statistic>
        </div>
      </a-col>
      <a-col :span="8" style="margin-bottom: 12px">
        <div
          class="statistic-module statistic-module_built"
          @click="$router.push({
            name: 'ServiceDashboardList',
            params: { statusType: 'built' }
          })"
        >
          <a-statistic
            title="已建"
            :value="dataSource.built"
            :valueStyle="{
              fontSize: '38px',
              lineHeight: '44px',
              textAlign: 'center',
              color: '#48b548',
              cursor: 'pointer'
            }"
          ></a-statistic>
        </div>
      </a-col>
      <a-col :span="8" style="margin-bottom: 12px">
        <div
          class="statistic-module statistic-module_building"
          @click="$router.push({
            name: 'ServiceDashboardList',
            params: { statusType: 'building' }
          })"
        >
          <a-statistic
            title="在建"
            :value="dataSource.building"
            :valueStyle="{
              fontSize: '38px',
              lineHeight: '44px',
              textAlign: 'center',
              color: '#4d94f8',
              cursor: 'pointer'
            }"
          ></a-statistic>
        </div>
      </a-col>
      <a-col :span="8" style="margin-bottom: 12px">
        <div
          class="statistic-module statistic-module_planned"
          @click="$router.push({
            name: 'ServiceDashboardList',
            params: { statusType: 'planned' }
          })"
        >
          <a-statistic
            title="拟建"
            :value="dataSource.planned"
            :valueStyle="{
              fontSize: '38px',
              lineHeight: '44px',
              textAlign: 'center',
              color: '#f19d48',
              cursor: 'pointer'
            }"
          ></a-statistic>
        </div>
      </a-col>
      <a-col :span="8" style="margin-bottom: 12px">
        <div
          class="statistic-module"
          @click="$router.push({
            name: 'ServiceDashboardList',
            params: { statusType: 'unknown' }
          })"
        >
          <a-statistic
            title="未知"
            :value="dataSource.unknown"
            :valueStyle="{
              fontSize: '38px',
              lineHeight: '44px',
              textAlign: 'center',
              color: 'rgba(0,0,0,.5)',
              cursor: 'pointer'
            }"
          ></a-statistic>
        </div>
      </a-col>
      <!-- <a-col :span="12" style="margin-bottom: 12px">
        <div class="statistic-module statistic-module_health">
          <a-statistic
            title="健康"
            :value="35"
            :valueStyle="{
              fontSize: '24px',
              lineHeight: '28px',
              textAlign: 'center',
              color: '#43b94d'
            }"
          ></a-statistic>
        </div>
      </a-col>
      <a-col :span="12" style="margin-bottom: 12px">
        <div class="statistic-module statistic-module_busy">
          <a-statistic
            title="繁忙"
            :value="35"
            :valueStyle="{
              fontSize: '24px',
              lineHeight: '28px',
              textAlign: 'center',
              color: '#fa8c16'
            }"
          ></a-statistic>
        </div>
      </a-col> -->
    </a-row>
  </div>
</template>

<script>
import { getServiceCount } from '@/api/service'
export default {
  name: 'ServiceStatistic',
  data () {
    return {
      dataSource: {
        all: 0,
        built: 0,
        building: 0,
        planned: 0,
        unknown: 0
      }
    }
  },
  created () {
    this.fetch()
  },
  methods: {
    fetch () {
      const dataSource = {
        all: 0,
        built: 0,
        building: 0,
        planned: 0,
        unknown: 0
      }
      getServiceCount().then(res => {
        if (res.data) {
          res.data.data.forEach(item => {
            dataSource.all += item.value
            dataSource[item.name] = item.value
          })
        }
        this.dataSource = dataSource
      })
    }
  }
}
</script>

<style lang="less" scoped>
.serviceStatistic-container {
  .statistic-module {
    padding: 24px 8px;
    background: #f6f7f9;
    border-radius: 6px;
    overflow: hidden;
    text-align: center;
    height: 118px;
  }
  .statistic-module_building {
    background: #f1f6fd;
  }
  .statistic-module_built{
    background: #f2faf2;
  }
  .statistic-module_planned{
    background: #fff9f3;
  }
}
</style>
